// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2T-is","textWrapper":"styles_textWrapper__2qxzV","link":"styles_link__2r3-0"};